import graphql__db67a8c5e8dc32fcedeb from "./__generated__/UserAuthorName_user.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";
import classNames from "classnames";

import Icon from "../Utils/Icon";

export const UserAuthorNameWithoutRelay = ({ ContainerComponent = "div", ...props }) => {
  const { user, name, withStatusName } = props;
  const { additionalViewerFields, statusName, isAdmin } = user;

  const isParticipant = statusName === "Participant";
  const userName = name || user.name;

  const statusIconClassName = classNames(
    "margin-right-xxs",
    { "icon-connexion": isParticipant },
    { "icon-people": !isParticipant }
  );

  return (
    <ContainerComponent className="contribution-author-name text-default">
      <span className="d-block contribution-autor-name-name text-legend">{userName}</span>

      {isAdmin && (
        <span className="d-block type text-secondary">
          <Icon className={statusIconClassName} />
        </span>
      )}

      {!isAdmin && withStatusName && (
        <span className="d-block type text-secondary">
          <Icon className={statusIconClassName} />
          {statusName}
        </span>
      )}

      {additionalViewerFields.map((fieldValue, index) => (
        <span key={index} className="d-block contribution-autor-name-additional-field">
          {fieldValue}
        </span>
      ))}
    </ContainerComponent>
  );
};

const UserAuthorName = props => {
  return <UserAuthorNameWithoutRelay {...props} />;
};

export default createFragmentContainer(UserAuthorName, {
  user: graphql__db67a8c5e8dc32fcedeb
});
